import gql from "graphql-tag";
import { CurrencyFragment } from "./currency.fragment";
import { PaymentTypeFragment } from "./payment.type.fragment";

export const PaymentGatewayFragment = gql`
  fragment PaymentGateway on PaymentGateway {
    id
    name
    sequence
    paymentGatewayProviderCode
    paymentMethodCode
    baseExchangeRate
    depositMarkupRate
    withdrawalMarkupRate
    depositExchangeRate
    withdrawalExchangeRate
    paymentTypeId
    baseCurrencyId
    pairCurrencyId
    isEditable
    isActive
    isArchived
    createdAt
    updatedAt
    createdBy
    updatedBy
    paymentGatewayTransactionType
    pairCurrency {
      ...CurrencyInfo
    }
    baseCurrency {
      ...CurrencyInfo
    }
    paymentType {
      ...PaymentType
    }
  }

  ${CurrencyFragment}
  ${PaymentTypeFragment}
`;
